import styled from 'styled-components'
import { BqDrawer, BqSelect, BqButton, BqCheckbox, BqOption, BqDivider } from '@beeq/react'

export const AdvancedSearchFilterLabel = styled.span`
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
`

export const AdvancedSearchFilterPercentajeTitle = styled.span`
  font-size: 14px;
`

export const FilterTagWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 4px 4px;
`

export const FilterTagColumnWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  row-gap: var(--bq-spacing-m);
`

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 24px;
  margin-top: 24px;
`

export const AdvancedSearchFilter = styled(BqDrawer)`
  --bq-drawer--width: 460px;
  --bq-drawer--paddingX: 40px;
  --bq-drawer--paddingY: 40px;

  &::part(panel) {
    z-index: 1001;
  }

  &::part(backdrop) {
    z-index: 1;
  }

  &::part(title) {
    font-size: 24px;
    line-height: 36px;
    font-weight: 700;
    padding-bottom: var(--bq-spacing-l);
  }
`

export const StyledFieldsWrapper = styled.div`
  overflow: auto;
  padding-right: 20px;
`

export const AdvancedSearchFilterSelect = styled(BqSelect)`
  &::part(label) {
    gap: 0;
    justify-content: space-between;
  }
`

export const AdvancedSearchButton = styled(BqButton)`
  &::part(button) {
    border-width: 0;
  }
`
export const StyledBqCheckbox = styled(BqCheckbox)`
  pointer-events: none;
`

export const StyledBqOption = styled(BqOption)`
  &::part(label) {
    display: flex;
    align-items: center;
  }
`

export const StyledBqDivider = styled(BqDivider)`
  &::part(base) {
    margin-bottom: var(--bq-spacing-m);
  }
`
